import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ typographyPresets }) => ({
    label: {
        ...typographyPresets.labelPrimary,
    },
    input: {
        marginRight: '10px',
        fontSize: '16px !important',
    },
    formCtrl: {
        margin: '10px 0',
    },
    checkbox: {
        display: 'flex',
    },
    error: {
        ...typographyPresets.labelPrimary,
        color: 'red',
        margin: '10px 2px',
    },
    labelContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    infoContainer: {
        position: 'relative',
    },
    info: {
        fontSize: '14px',
        color: 'black',
    },
    tooltip: {
        position: 'absolute',
        top: '50%',
        right: '20px',
        fontSize: '11px',
        transform: 'translateY(-50%)',
        color: 'white',
        background: 'black',
        padding: '5px',
        borderRadius: '3px',
        '&:before': {
            position: 'absolute',
            content: "''",
            borderColor: 'transparent',
            borderStyle: 'solid',
        },
    },
}))
